








import Component, { mixins } from "vue-class-component";
import AxiosMixin from "../../mixins/axiosMixin";
import { Emit } from "vue-property-decorator";
import Cookies from "js-cookie";

@Component
export default class MockToken extends mixins(AxiosMixin) {
  authOnetime() {
    //これはiBowで叩く想定
    this.postJsonCheck(
      window.base_url + "/auth/onetime",
      {
        ibow_url: "https://customer-7378.e-ibow.jp/",
        user_id: "ibowadmin4",
        user_name: "テストユーザー",
        password: "100"
      },
      res => {
        //URLにonetime_tokenが入っている場合にその値を使ってどこかで叩く想定
        this.postJsonCheck(
          window.base_url + "/auth/fromonetime",
          { one_time_token: res.data.one_time_token },
          res2 => {
            window.token = res2.data.token;
            Cookies.set("token", window.token);
            window.reftoken = res2.data.ref_token;
            Cookies.set("reftoken", window.reftoken);
            window.user_name = res2.data.user_name;
            Cookies.set("user_name", window.user_name);
            this.token();
          }
        );
      }
    );
  }

  @Emit()
  private token() {
    return;
  }
}
